import React from 'react';
import { useSelector } from 'react-redux';

import { getArea } from 'core/selectors';

import { BannersCarousel } from './BannersCarousel';

export const Container = () => {
  const { banners } = useSelector(getArea);

  if (!banners.length) {
    return null;
  }

  return <BannersCarousel items={banners} />;
};
